import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import NewSlideRightArrowIcon from "../../images/new-slide-right-icon.svg";
import NewSlideLeftArrowIcon from "../../images/new-slide-left-icon.svg";
import "./ParentSlideNavigation.scss";
import { toggleLeftPanel } from "../../utils/editorUtils/commonFunctions";
import {
  addNewChildSlide,
  navigateToPrevChildAndParent,
  navigateToNextChildAndFromParent,
  inParent,
  lastChild,
} from "./ChildSlideCrND";
import { showErrorToast } from "../toastComponent/ToastComponent";
const SlideNextAndPrevious = ({
  slideID,
  setSlideID,
  currentSlide,
  setCurrentSlide,
  setSlideCount,
  editor,
  appData,
  childSlideCount,
  setChildSlideCount,
  loadSuccess,
  setLoadSuccess,
  setSaveLoading,
  slideCount,
  slideCountDisplay,
  setSlideCountDisplay,
  inputElement,
}) => {
  let navigate = useNavigate();
  const [prompt, setPrompt] = useState(false);
  const [slideNavigationSpacing, setSlideNavigationSpacing] = useState(9);
  const [currentSlideNavigationSpacing, setCurrentSlideNavigationSpacing] = useState(9);
  const [totalSlideNavigationSpacing, setTotalSlideNavigationSpacing] = useState(9);
  useEffect(()=>{
    // Per digit/character 9px and half character size for '.'
    const currentSlideNavigationDisplayValue = JSON.stringify(currentSlide.child) === "{}" ? ((slideCountDisplay+'').length) : ((childSlideCount+'').length- 0.5);
    setCurrentSlideNavigationSpacing(currentSlideNavigationDisplayValue*9);
    setTotalSlideNavigationSpacing((slideID?.length+'').length*9);
  }, [slideCountDisplay, childSlideCount, slideID]);

  let list = [];
  const nextPage = async () => {
    // console.log('leee');
    if (!loadSuccess) return;
    setLoadSuccess(false);
    toggleLeftPanel();
    let currentPage = filterCurrentPage();
    let slideIDInstance = JSON.parse(JSON.stringify(slideID));
    if (currentPage < slideID.length - 1) {
      navigate(`/editor/${slideID[currentPage + 1].slideid?._id}`);
      setCurrentSlide({ master: slideIDInstance[currentPage + 1], child: {} });
      setSaveLoading(true);
      
      // editor.editor.attributes.PageManager.select(
      //   slideID[currentPage + 1].slideid?._id
      // );
      
      setTimeout(() => {
        setSlideID(slideIDInstance);
        setSlideCount(currentPage + 2);
      }, 1500);
    } else if (currentPage === slideID.length - 1) return;
    toggleLeftPanel();
  };
  const jumpToTheSlide = (e, origin) => {
    const value =
      e.target.value !== ""
        ? isNaN(Number(e.target.value)) || e.target.value.includes(".")
          ? slideCount
          : Number(e.target.value)
        : e.target.value;

    if (value / 1000 >= 1) return;

    setSlideCountDisplay(value);
    if (e.code === "Enter" || e.type === "blur") {
      if (value === "") {
        showErrorToast('Please enter the slide number!');
        setSlideCountDisplay(slideCount);
        return;
      }
      if (value <= slideID?.length && e.target?.value > 0) {
        setCurrentSlide({ ...currentSlide, master: slideID[value - 1] });
        navigate(`/editor/${slideID[value - 1].slideid?._id}`);
        setSlideCount(value);
        document?.getElementById("jumpToSlide")?.blur();
      } else {
        if (value !== 0 && !e.target.value.includes("-"))
          showErrorToast('Entered value exceeds the overall number of slides');
        setSlideCountDisplay(slideCount);
      }
    }
  };
  const filterCurrentPage = () => {
    return slideID.findIndex(
      (slide) => slide.slideid?._id === currentSlide.master.slideid?._id
    );
  };
  const previousPage = async () => {
    if (!loadSuccess) return;
    setLoadSuccess(false);

    let currentPage = filterCurrentPage();
    let slideIDInstance = JSON.parse(JSON.stringify(slideID));
    toggleLeftPanel();
    if (currentPage > 0) {
      navigate(`/editor/${slideID[currentPage - 1].slideid?._id}`);
      setSaveLoading(true)
      setCurrentSlide({ master: slideIDInstance[currentPage - 1], child: {} });
      setTimeout(() => {
        setSlideCount(currentPage);
        setSlideID(slideIDInstance);
      }, 1500);
    } else if (currentPage === 0) {
      return;
    }
  };

  // const getCurrentMasterSlideIndex = () => {
  //   return (
  //     slideID?.findIndex(
  //       (slide) => slide?.slideid?._id === currentSlide?.master?.slideid?._id
  //     ) + 1
  //   );
  // };
  const validateDelete = () => {
    // if (
    //   slideID.length === 1 ||
    //   (JSON.stringify(currentSlide.child) !== "{}" &&
    //     currentSlide?.master?.children.length > 1)
    // )
    //   return;
    // if (JSON.stringify(currentSlide?.child) !== "{}")
    //   if (currentSlide?.master?.children?.length === 1) return;

    // setPrompt(slideID?.length > 1);
    setPrompt(
      JSON.stringify(currentSlide?.child) === "{}"
        ? slideID.length > 1
          ? true
          : false
        : true
    );
  };
  //new script
  // const deleteChildSlide = () => {
  //   toggleLeftPanel();
  //   let currentPageIndex = currentSlide?.master?.children?.findIndex(
  //     (child) => child?.slideid?._id === currentSlide?.child?.slideid?._id
  //   );

  //   let tempCurrentSlide = JSON.parse(JSON.stringify(currentSlide));
  //   let deleteChildFromMasterPayload = {
  //     children: [currentSlide?.child?.slideid?._id],
  //   };
  //   deleteChildSlideFromMaster(
  //     appData.deckId._id,
  //     tempCurrentSlide?.master?.slideid?._id,
  //     deleteChildFromMasterPayload,
  //     async (response, err, errorCode) => {
  //       if (err) {
  //       } else {
  //         let tempSLidesList = JSON.parse(JSON.stringify(slideID));
  //         if (tempCurrentSlide?.master?.children === 1) {
  //           tempCurrentSlide.master.children = [];
  //           tempCurrentSlide.child = {};
  //           navigate(`/editor/${tempCurrentSlide?.master?.slideid?._id}`);
  //         } else {
  //           tempCurrentSlide?.master?.children?.splice(currentPageIndex, 1);
  //           sortSLidesAfterDelete(
  //             tempCurrentSlide?.master?.children,
  //             currentSlide.master.index - 1
  //           );
  //           tempCurrentSlide.child = {};
  //           navigate(`/editor/${tempCurrentSlide?.master?.slideid?._id}`);
  //         }
  //         setCurrentSlide(tempCurrentSlide);
  //         let currentIndex = slideID.findIndex(
  //           (slide) =>
  //             slide.slideid?._id === tempCurrentSlide.master.slideid?._id
  //         );
  //         tempSLidesList[currentIndex] = tempCurrentSlide.master;
  //         setSlideID(tempSLidesList);
  //         window.localStorage.setItem(
  //           "removedSlieId",
  //           currentSlide?.child?.slideid?._id
  //         );
  //       }
  //     }
  //   );
  // };

  //end
  const sortSLidesAfterDelete = (tempSlideId, initVal) => {
    for (let i = initVal; i < tempSlideId.length; i++) {
      tempSlideId[i].index = i + 1;
    }
  };

  const getClassName = () => {
    return JSON.stringify(currentSlide?.child) === "{}"
      ? slideID.length > 1
        ? "new-slide-delete-icon"
        : "disableDelete "
      : "new-slide-delete-icon";
  };
  const lastPage = () => {
    return slideID?.length > 0
      ? slideID[slideID.length - 1].slideid?._id ===
          currentSlide?.master?.slideid?._id
      : false;
  };
  const firstPage = () => {
    return slideID?.length > 0
      ? slideID[0].slideid?._id === currentSlide?.master?.slideid?._id
      : false;
  };
  return (
    <>
      <ul
        style={{ display: "flex" }}
        className="parent-navigation middle-pannel-total-slides"
      >
        <li>
          <img
            src={NewSlideLeftArrowIcon}
            className={firstPage() ? "disableNavigate" : "new-slide-left-icon"}
            style={{ cursor: "pointer" }}
            alt=""
            onClick={() => !firstPage() && previousPage("prev")}
          />
        </li>
        <div className="slideNoCount">
          {JSON.stringify(currentSlide.child) === "{}" ? (
            <>
              <span
                className="slideNavigationSpacing"
                style={{ width: `${slideNavigationSpacing}px` }}
              ></span>
              <input
                autofocus
                id="jumpToSlide"
                className={"jumpToSlideIp"}
                type="text"
                min="1"
                value={slideCountDisplay}
                onChange={jumpToTheSlide}
                onKeyUp={jumpToTheSlide}
                onBlur={jumpToTheSlide}
                style={{ width: `${currentSlideNavigationSpacing}px`}}
              ></input>
              <span className="slide-text"> / </span>
              <span className="slide-text slideTotalCount"
                style={{ width: `${totalSlideNavigationSpacing}px`}}
                >
                {slideID?.length}
              </span>
              <span
                className="slideNavigationSpacing"
                style={{ width: `${slideNavigationSpacing}px` }}
              ></span>
            </>
          ) : (
            <>
              <span
                className="slideNavigationSpacing"
                style={{ width: `${slideNavigationSpacing}px` }}
              ></span>
              <input
                autofocus
                id="jumpToSlide"
                className={"jumpToSlideIp"}
                type="text"
                min="1"
                value={childSlideCount}
                onChange={jumpToTheSlide}
                onKeyUp={jumpToTheSlide}
                onBlur={jumpToTheSlide}
                style={{ width: `${currentSlideNavigationSpacing}px`}}
              ></input>
              <span className="slide-text"> / </span>
              <span className="slide-text slideTotalCount"
                style={{ width: `${totalSlideNavigationSpacing}px`}}
              >
                {slideID?.length}
              </span>
              <span
                className="slideNavigationSpacing"
                style={{ width: `${slideNavigationSpacing}px` }}
              ></span>
            </>
          )}
        </div>
        <li>
          <img
            src={NewSlideRightArrowIcon}
            className={lastPage() ? "disableNavigate" : "new-slide-right-icon"}
            style={{ cursor: "pointer" }}
            alt=""
            onClick={() => !lastPage() && nextPage("next")}
          />
        </li>
      </ul>
      <div className="arrows-right-down">
        <ul>
          <li className="top-child-navigation">
            <img
              src={NewSlideLeftArrowIcon}
              // className="up-arrow"
              className={
                inParent(currentSlide) ? "up-arrow-disabled" : "up-arrow"
              }
              style={{ cursor: "pointer" }}
              alt=""
              onClick={() => {
                !inParent(currentSlide) &&
                  navigateToPrevChildAndParent({
                    currentSlide,
                    setCurrentSlide,
                    setChildSlideCount,
                    setSlideCount,
                    editor,
                    navigate,
                    slideID,
                    setSlideID,
                    inputElement,
                    setLoadSuccess,
                    setSaveLoading,
                    loadSuccess,
                  });
              }}
            />
          </li>
          <li className="down-child-navigation">
            <img
              src={NewSlideRightArrowIcon}
              className={
                lastChild(currentSlide) ? "down-arrow-disabled" : "down-arrow"
              }
              style={{ cursor: "pointer" }}
              alt=""
              onClick={() => {
                !lastChild(currentSlide) &&
                  navigateToNextChildAndFromParent({
                    currentSlide,
                    setCurrentSlide,
                    setChildSlideCount,
                    setSlideCount,
                    editor,
                    navigate,
                    slideID,
                    setSlideID,
                    inputElement,
                    setLoadSuccess,
                    setSaveLoading,
                    loadSuccess,
                  });
              }}
            />
          </li>
        </ul>
      </div>
    </>
  );
};

export default SlideNextAndPrevious;
